import * as React from "react";
import { UitkLink } from "uitk-react-link";
import { ImageMediaType } from "src/components/flexComponents/Editorial/typings";
import { LazyLoadedImage } from "src/components/utility/LazyLoadedImage/LazyLoadedImage";

export const ImageEditorialWithLink = ({ mediaUrl, mediaAlt, clickUrl }: ImageMediaType) => (
  <UitkLink>
    <a href={clickUrl}>
      <LazyLoadedImage key={mediaUrl} alt={mediaAlt} src={mediaUrl} className="images-size" />
    </a>
  </UitkLink>
);

export default ImageEditorialWithLink;
